import { useRef } from 'react';
import { MovingGradient } from '../../../../../../ReactSharedScripts/components/MovingGradient';
import { generateListItems } from '../../../../../../ReactSharedScripts/modules/list/listPage/ListLoadingPlaceholder/utils';
import Spreadsheet, {
	SpreadsheetAvatar,
	SpreadsheetBody,
	SpreadsheetBodyRow,
	SpreadsheetBodyRowItem,
	SpreadsheetBodyRowItemNavigation,
	SpreadsheetColumnSwitcher,
	SpreadsheetHead,
	SpreadsheetHeadRow,
	SpreadsheetHeadRowItem,
} from '../../components/Spreadsheet';
import { SpreadsheetBodyRowCheckboxLayout } from '../../components/Spreadsheet/SpreadsheetBodyRowCheckboxLayout';
import { SpreadsheetHeadRowCheckboxLayout } from '../../components/Spreadsheet/SpreadsheetHeadRowCheckboxLayout';

const minContentWidth = 30;
const maxContentWidth = 90;
const minTitleWidth = 25;
const maxTitleWidth = 55;

type ListLoadingPlaceholderListItemsProps = {
	hasMultiselect?: boolean;
	columnsCount?: number;
	rowsCount?: number;
	skipNavigation?: boolean;
	hasAvatar?: boolean;
	avatarColumnIndex?: number;
	skipCollapse?: boolean;
	hasColumnSwitcher?: boolean;
};

function ListLoadingPlaceholderListItems({
	hasMultiselect,
	columnsCount = 5,
	rowsCount = 12,
	skipNavigation,
	hasAvatar,
	avatarColumnIndex = 0,
	hasColumnSwitcher,
}: ListLoadingPlaceholderListItemsProps) {
	// const columnsWidthRef = useRef(getCellsWidth(columnsCount));
	const columnsRef = useRef(getColumns(columnsCount));
	const listItems = generateListItems(rowsCount);

	return (
		<>
			<Spreadsheet minWidth='700px'>
				<SpreadsheetHead>
					<SpreadsheetHeadRow
						hasCheckbox={hasMultiselect}
						hasAvatar={hasAvatar}
						hasColumnSwitcher={hasColumnSwitcher}
						hasNavigation={!skipNavigation}
						styles={{
							marginBottom: hasMultiselect ? 0 : '9.5px',
						}}
					>
						{hasMultiselect && <SpreadsheetHeadRowCheckboxLayout disabled />}
						{columnsRef.current.map((column) => {
							return (
								<SpreadsheetHeadRowItem
									key={column.name}
									// width={column.columnWidth}
								>
									{column.title}
								</SpreadsheetHeadRowItem>
							);
						})}
						{hasColumnSwitcher && (
							<SpreadsheetColumnSwitcher
								disabled
								items={[
									{
										name: 'dsd',
										visible: false,
									},
								]}
							/>
						)}
					</SpreadsheetHeadRow>
				</SpreadsheetHead>
				<SpreadsheetBody>
					{listItems?.map((_, listItemIndex) => {
						return (
							<SpreadsheetBodyRow
								key={listItemIndex}
								hasCheckbox={hasMultiselect}
								hasAvatar={hasAvatar}
							>
								{hasMultiselect && <SpreadsheetBodyRowCheckboxLayout disabled />}
								{columnsRef.current.map(({ name }, columnIndex) => {
									const contentWidth =
										Math.random() * (maxContentWidth - minContentWidth) + minContentWidth;
									const renderAvatar = hasAvatar && avatarColumnIndex === columnIndex;
									const hasMultiline = !renderAvatar && contentWidth > maxContentWidth / 1.5;

									return (
										<SpreadsheetBodyRowItem
											key={name}
											// width={columnWidth}
										>
											{renderAvatar && (
												<SpreadsheetAvatar
													size='large'
													title={
														<MovingGradient
															height='14px'
															width={`${contentWidth}%`}
														/>
													}
												/>
											)}
											{!renderAvatar && (
												<MovingGradient
													height='14px'
													width={`${contentWidth}%`}
												/>
											)}
											{hasMultiline && (
												<MovingGradient
													height='14px'
													width={`${maxContentWidth + minContentWidth - contentWidth}%`}
													style={{
														marginTop: '4px',
													}}
												/>
											)}
										</SpreadsheetBodyRowItem>
									);
								})}
								{!skipNavigation && <SpreadsheetBodyRowItemNavigation disabled />}
								{skipNavigation && hasColumnSwitcher && (
									<div
										style={{
											width: '56px',
											minHeight: '1px',
											marginLeft: '10px',
										}}
									></div>
								)}
							</SpreadsheetBodyRow>
						);
					})}
				</SpreadsheetBody>
			</Spreadsheet>
		</>
	);
}

function getColumns(count) {
	return Array.from({ length: count }, (_, i) => {
		// const columnWidth = columnsWidth[i];
		const titleWidth = Math.random() * (maxTitleWidth - minTitleWidth) + minTitleWidth;

		return {
			name: getCellName(i),
			visible: true,
			// columnWidth: `${5}%`,
			title: (
				<MovingGradient
					height='14px'
					width={`${titleWidth}%`}
				/>
			),
		};
	});
}

function getCellName(index) {
	return `cell__${index}`;
}

// function getCellsWidth(columnCount) {
// 	const min = 8;
// 	const max = 25;

// 	const randomNumbers = Array.from({ length: columnCount }, () => Math.random() * (max - min) + min);
// 	const sum = randomNumbers.reduce((acc, num) => acc + num, 0);
// 	const columnWidths = randomNumbers.map((num) => Math.round((num / sum) * 100));

// 	return columnWidths;
// 	let roundingError = 100 - columnWidths.reduce((a, b) => a + b, 0);

// 	for (let i = 0; roundingError !== 0; i++) {
// 		const selectedIndex = i % columnCount;

// 		if (roundingError > 0 && columnWidths[selectedIndex] < max) {
// 			columnWidths[selectedIndex]++;
// 			roundingError--;
// 		} else if (roundingError < 0 && columnWidths[selectedIndex] > min) {
// 			columnWidths[selectedIndex]--;
// 			roundingError++;
// 		}
// 	}

// 	return columnWidths;
// }

export { ListLoadingPlaceholderListItems };
